import { Component, OnInit, Input } from '@angular/core';
import { FindInspectionService } from '../../services/find-inspection.service';
import { InspectionRowViewModel, EqAndInspectionIds } from '../../models/find-inspection.model';
import { Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-thermography-list-row',
  templateUrl: './thermography-list-row.component.html',
  styleUrls: ['./thermography-list-row.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class ThermographyListRowComponent implements OnInit {

   //@Input() inspectionId: number;
   @Input() EQnInspectionIds : EqAndInspectionIds;
   public inspection: InspectionRowViewModel;
   public loadingRow: boolean = true;
 
   constructor(private _findInspection: FindInspectionService,
     private _router: Router) { }
 
   ngOnInit() {
     this.loadRowData();
   }
 
   getEval(value:string){
     return value;
    
   }
   loadRowData() {
     this._findInspection.getThermographyInspectionRow(this.EQnInspectionIds.InspectionId).subscribe(r => {
       this.inspection = r;
       console.log("InspectionINfo___", this.inspection)
       this.loadingRow = false;
     });
   }
 
   openInspection() {
    //  this._router.navigate(['thermography-inspection', this.EQnInspectionIds.EquipmentId , this.EQnInspectionIds.InspectionId]);
    window.open('/thermography-inspection/' + this.EQnInspectionIds.EquipmentId + '/' + this.EQnInspectionIds.InspectionId, '_blank');
   }
 
 
 }
 